import { Box, Stack } from "@mui/material";

interface ILegacyContentWrapper {
  children: React.ReactNode;
}

/**
 * @returns A wrapper for old pages that need top and side padding for app header and vack navigation button.
 */
const LegacyContentWrapper = ({ children }: ILegacyContentWrapper) => {
  return (
    <Stack
      sx={{
        width: "100%",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: "1180px" }}>{children}</Box>
    </Stack>
  );
};

export default LegacyContentWrapper;
